import React from 'react';
import "../assets/css/app.css";
import Index from './index/Index';

class App extends React.Component {
  render() {
    return (
      <div className="app-show">
        <Index />
      </div>
    );
  }
}

export default App;
